module.exports = __webpack_public_path__ + "img/logo2.23a15b75.png";